module.exports = __webpack_public_path__ + "static/media/fiu_logo.830a1275.svg";